import { render, staticRenderFns } from "./docSendCreate.vue?vue&type=template&id=1c99008d&scoped=true"
import script from "./docSendCreate.vue?vue&type=script&lang=js"
export * from "./docSendCreate.vue?vue&type=script&lang=js"
import style0 from "./docSendCreate.vue?vue&type=style&index=0&id=1c99008d&prod&lang=less&scoped=true"
import style1 from "./docSendCreate.vue?vue&type=style&index=1&id=1c99008d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c99008d",
  null
  
)

export default component.exports